import axios from 'axios';
import { camelizeKeys } from 'humps';

import { config } from '@/config';

const instance = axios.create({
  timeout: config.axiosTimeout,
});

export const request = async (params, camelize = true) => {
  const response = await instance(params);
  const result = response.data ? response.data : response;

  return camelize ? camelizeKeys(result) : result;
};

export default request;
